// ══════════════════════════════════════════════
//  Fogón — Constants & Session Helpers
//  DEFAULT_* se mantienen como fallback.
//  Usar getActive*() en toda la aplicación.
// ══════════════════════════════════════════════

export const DEFAULT_COMPANY_ID = 'COMPANY001';
export const DEFAULT_PREMISE_ID = 1;

/** Retorna el idCompany activo de la sesión, o el default como fallback */
export function getActiveCompanyId(): string {
  return sessionStorage.getItem('idCompany') || DEFAULT_COMPANY_ID;
}

/** Retorna el idPremise activo de la sesión, o el default como fallback */
export function getActivePremiseId(): number {
  const stored = sessionStorage.getItem('idPremise');
  return stored ? parseInt(stored, 10) : DEFAULT_PREMISE_ID;
}
